@if (isLoading()) {
  <div class="overlay">
    <div class="overlay-content"></div>
    <p-progressSpinner></p-progressSpinner>
  </div>
}
